import { alignmentWizardModeReducer } from "./alignment-wizard-mode-slice";
import { cloudCadAlignmentModeReducer } from "./cloud-cad-alignment-mode-slice";
import { cloudToSheetAlignmentModeReducer } from "./cloud-to-sheet-alignment-mode-slice";
import { controlPointsAlignmentModeReducer } from "./control-points-alignment-mode-slice";
import { exportModeReducer } from "./export-mode-slice";
import { flyWalkModeReducer } from "./flywalk-mode-slice";
import { importSheetModeReducer } from "./import-sheet-mode-slice";
import { sheetCadAlignmentModeReducer } from "./sheet-cad-alignment-mode-slice";
import { sheetToCloudAlignmentModeReducer } from "./sheet-to-cloud-alignment-mode-slice";
import { sheetToSheetAlignmentModeReducer } from "./sheet-to-sheet-alignment-mode-slice";
import { walkModeReducer } from "./walk-mode-slice";

export const modesReducers = {
  walkMode: walkModeReducer,
  sheetCadAlignmentMode: sheetCadAlignmentModeReducer,
  cloudCadAlignmentMode: cloudCadAlignmentModeReducer,
  alignmentWizardMode: alignmentWizardModeReducer,
  sheetToCloudAlignmentMode: sheetToCloudAlignmentModeReducer,
  sheetToSheetAlignmentMode: sheetToSheetAlignmentModeReducer,
  exportMode: exportModeReducer,
  controlPointsAlignmentMode: controlPointsAlignmentModeReducer,
  cloudToSheetAlignmentMode: cloudToSheetAlignmentModeReducer,
  importSheetMode: importSheetModeReducer,
  flyWalkMode: flyWalkModeReducer,
};
